var $ = require("jquery");
window.jQuery = $;
window.$ = $;

import Shuffle from "./vendor/shuffle";

(function () {
  var $container = $(".js-shuffle");
  var shuffle = [];
  var reshuffle = false;

  if ($container.length === 0) return false;

  // initialise grid (images only in DOM for first X items - see template)
  $(document).ready(function () {
    var init = {
      itemSelector: ".shuffle-item",
      sizer: ".shuffle-sizer",
      buffer: 1,
    };
    $(".js-shuffle").each(function (index) {
      shuffle[$(this).attr("data-shuffle-index")] = new Shuffle($(this), init);
    });

    function isElementInViewport(el) {
      if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
      }
      var rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */ &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
      );
    }

    $("#tabs-menu button.shuffle").on("click", function () {
      shuffle[$(this).data("index")].enable();
    });
  });
})();
